import { PersonalInfo } from '@/types/portfolio'

export const personalInfo: PersonalInfo = {
  id: '1',
  name: 'Bytethecarrot.dev',
  title: 'Frontend Engineer, Full-stack Engineer',
  bio: "I'm a Budapest-based Art director & Brand designer. My experience spans various fields including branding, product design, webdesign. I approach design by blending creativity with strategic thinking, while guiding and inspiring other creatives to deliver impactful, innovative work.",
  email: 'hello@bytethecarrot.dev',
  profileImage: '/logos/logo1.webp',
  location: 'Budapest, Hungary',
  social_profiles: {
    linkedin: 'http://linkedin.com/in/bytethecarrot-dev',
    twitter: 'https://x.com/bytethecarrot',
    email: 'hello@bytethecarrot.dev',
    github: 'http://github.com/carr-o-t',
  },
  createdAt: new Date('2024-01-01'),
  updatedAt: new Date('2024-12-26'),
}
